import rg4js from 'raygun4js';
import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '@env/environment';

const VERSION_NUMBER = '1.0.0.0';

@Injectable()
export class RaygunErrorHandler implements ErrorHandler {
  constructor() {
    rg4js('apiKey', environment.rg_api);
    rg4js('setVersion', VERSION_NUMBER);
    rg4js('enableCrashReporting', true);
    rg4js('logContentsOfXhrCalls', true);
  }

  handleError(err: any) {
    console.error(err);
    if (err instanceof Error) {
      rg4js('send', {
        error: `ErrorName: ${err?.name ?? 'none'}, ErrorMessage: ${err?.message ?? 'none'} ErrorStack: ${err?.stack ?? 'none'}`,
        tags: ['application error'],
      });
    }
  }
}
